import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useRef, useEffect } from 'react';
import { useIntersection } from 'react-use';
import { jsxs as _jsxs } from "react/jsx-runtime";

const ArticleSectionHeader = _ref => {
  let {
    elementId,
    name = '',
    className = '',
    onToggleVisible,
    children
  } = _ref;
  const intersectionRef = useRef(null);
  const intersection = useIntersection(intersectionRef, {
    root: null,
    rootMargin: '0px',
    threshold: 1
  });
  const isVisible = intersection && intersection.isIntersecting ? true : false;
  useEffect(() => {
    if (onToggleVisible) {
      onToggleVisible(isVisible, elementId);
    }
  }, [elementId, onToggleVisible, isVisible]);
  return /*#__PURE__*/_jsxs("h3", _objectSpread(_objectSpread(_objectSpread({}, elementId && {
    id: elementId
  }), className && {
    className
  }), {}, {
    // @ts-ignore
    ref: intersectionRef,
    children: [name, children]
  }));
};

export default ArticleSectionHeader;